export enum DisplayInlineTextTypes {
  default = 'default',
  personal = 'personal',
  fare = 'fare',
  noprogram = 'noprogram',
  rewards = 'rewards'
}

export const PartnerIdConfigs: {
  [key: string]: {
    restrictPaxToOne: boolean;
    disableMiles: boolean;
    displayInlineText: DisplayInlineTextTypes;
  };
} = {
  default: {
    restrictPaxToOne: false,
    disableMiles: false,
    displayInlineText: DisplayInlineTextTypes.default
  },
  personal: {
    restrictPaxToOne: false,
    disableMiles: false,
    displayInlineText: DisplayInlineTextTypes.personal
  },
  edp: {
    restrictPaxToOne: false,
    disableMiles: true,
    displayInlineText: DisplayInlineTextTypes.fare
  },
  'concur-spid': {
    restrictPaxToOne: true,
    disableMiles: true,
    displayInlineText: DisplayInlineTextTypes.fare
  },
  'concur-no-spid': {
    restrictPaxToOne: true,
    disableMiles: true,
    displayInlineText: DisplayInlineTextTypes.noprogram
  },
  hipmunk: {
    restrictPaxToOne: true,
    disableMiles: true,
    displayInlineText: DisplayInlineTextTypes.fare
  },
  'nutravel-spid': {
    restrictPaxToOne: false,
    disableMiles: true,
    displayInlineText: DisplayInlineTextTypes.fare
  },
  'nutravel-sme': {
    restrictPaxToOne: false,
    disableMiles: true,
    displayInlineText: DisplayInlineTextTypes.rewards
  },
  'nutravel-skyb': {
    restrictPaxToOne: false,
    disableMiles: false,
    displayInlineText: DisplayInlineTextTypes.rewards
  },
  'nutravel-no-program': {
    restrictPaxToOne: false,
    disableMiles: true,
    displayInlineText: DisplayInlineTextTypes.noprogram
  },
  'standalone-sky': {
    restrictPaxToOne: false,
    disableMiles: true,
    displayInlineText: DisplayInlineTextTypes.rewards
  },
  'standalone-oa-sme': {
    restrictPaxToOne: false,
    disableMiles: true,
    displayInlineText: DisplayInlineTextTypes.rewards
  },
  'standalone-sky-skyb': {
    restrictPaxToOne: false,
    disableMiles: false,
    displayInlineText: DisplayInlineTextTypes.rewards
  },
  kayak4biz: {
    restrictPaxToOne: false,
    disableMiles: true,
    displayInlineText: DisplayInlineTextTypes.default
  }
};
